/*
* This pack contains logic that only pertains to
* the customer portal.
*/
import '../customer';
